import React, { ReactNode, useCallback } from 'react'
import { Text } from '../../../common/components/text/Text'
import { Main } from '../../../common/components/main/Main'
import { Button } from '../../../common/components/button/Button'
import Card from '../../../common/components/card/Card'
import Icons from '../../../common/components/icon/Icon'
import { Flex } from '../../../common/components/flex/Flex'
import { Space } from '../../../common/components/space/Space'
import { Table } from '../../../common/components/table/Table'
import { Col, Modal, OverlayTrigger, Pagination, Row, Tooltip } from 'react-bootstrap'
import '../../../common/components/pagination/Pagination.scss'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { format, parseISO } from 'date-fns'
import {
  cmpTypeListGetAction,
  cmpTypeSetSelectedAction,
} from '../../../store/action/cmpTypeAction'
import AddCompany from './pageContainer/AddCompany'
import { useState } from 'react'
import typeService from '../../../services/typeService'
import swal from 'sweetalert'
import Loader from 'react-loader-spinner'
import { InputWithIcon } from '../../../common/components/control/Control'

const CompanyTypesList = (props: any) => {
  const { cmpTypes, isLoading, totalPage, totalElement } = props
  const [displayCompany, setCompany] = React.useState<any>([])
  const [page, setPage] = React.useState(0)
  const [showModal, setModal] = React.useState(false)
  const [pagination, setPagination] = React.useState([{}])
  const [isEdit, setIsEdit] = useState(false)
  const [isview, setIsView] = useState(false)
  const [isAdd, setIsAdd] = useState(false)
  const [high, setHigh] = useState(9)
  const [low, setLow] = useState(1)
  const perPage = 9
  // const headerName = 'ROLE DETAIL'
  // const filename ="role__" + new Date()
  //const [searchInput, setSearchInput] = React.useState('')
  // const [searchQuery , setQuery] = useState('')
  const [showDelete, setShow] = React.useState(false);
  const [deleteCmpType, setDeleteCmpType] = React.useState(0)
  const [searchInput, setSearchInput] = React.useState('')

  React.useEffect(() => {
    //const { totalPage } = props
    const arrayPage = Array.from(Array(props.totalPage).keys())
    setPagination(arrayPage)
  }, [props.totalPage])

  React.useEffect(() => {
    props.cmpTypeListGetAction({ size: 10, page })
  }, [totalElement, page])


  React.useEffect(() => {
    if (cmpTypes && cmpTypes.length > 0) {
      // console.log(cmpTypes, 'cmpTypes')
      setCompany(() => {
        return cmpTypes.map((s: any) => ({ ...s, checked: false }))
      })
    }
    if (cmpTypes && cmpTypes.length === 0) {
      setCompany([])
    }
  }, [cmpTypes, page])


  const _willViewEdit = (detail: string | number | any) => {
    props.cmpTypeSetSelectedAction(detail)
    setModal(true)
    setIsView(false)
    setIsEdit(true)
  }

  const _willViewDetail = (detail: string | number | any) => {
    props.cmpTypeSetSelectedAction(detail)
    setModal(true)
    setIsView(true)
    setIsEdit(false)
  }

  // Delete the pericular list.
  const handleClose = () => setShow(false);
  const handleShow = (cmpType: any) => {
    setShow(true);
    setDeleteCmpType(cmpType.id)
    // console.log(deleteAnode, 'deleted anode id')
  }

  const _willDelete = () => {
    // console.log(deleteAnode, 'deleted anode id')
    _deleteCmpType(deleteCmpType)
  }

  const _deleteCmpType = (id: any) => {
    return typeService.deleteCompanyType(id).subscribe({
      next: (r) => {
        // console.log(r, 'response')
        setShow(false)
        swal("Great", " Deleted Successfully", "success")
        props.cmpTypeListGetAction({ size: 10, page })
      },
      error: err => {
        swal("OOPS", String(err), "error")
      }
    })
  }

  const _willAddNewCompany = () => {
    props.cmpTypeSetSelectedAction(null)
    setModal(true)
    setIsAdd(true)
    setIsEdit(false)
    setIsView(false)
  }
  const _willCloseModal = () => {
    props.cmpTypeListGetAction({ size: 10, page: 0 })
    setModal(false)
    setPage(0)
  }

  const _showAll = () => {
    setSearchInput('')
    props.cmpTypeListGetAction({ size: 10, page: 0 })
  }

  const _searchFuntion = (value: string) => {
    setSearchInput(value)
    props.cmpTypeListGetAction({ size: 10, page: 0 })
    setPage(0)
  }

  const _goPrevPage = () => {
    setPage(prev => {
      return (prev -= 1)
    })
  }

  const _goNextPage = () => {
    setPage(prev => {
      return (prev += 1)
    })
  }

  const _goToPage = (page: any) => {
    setPage(page)
  }

  const firstPage = () => {
    if (page >= 1) {
      return <Pagination.First onClick={() => _goToFirstPage()}>First</Pagination.First>
    }
  }

  const _goToLastPage = () => {
    setPage(totalPage - 1)
    setHigh(totalPage - 1)
    setLow(totalPage - 10)
  }

  const _goToFirstPage = () => {
    setPage(0)
    setHigh(10)
    setLow(1)
  }

  const lastPage = () => {
    if (page !== totalPage - 1) {
      if (page <= high) {
        return <Pagination.Last onClick={() => _goToLastPage()}>Last</Pagination.Last>
      }
    }
  }

  const prevBtn = () => {
    if (page >= 1) {
      if (page + 1 === low) {
        setHigh(high - perPage)
        setLow(low - perPage)
      }
      return <Pagination.Prev onClick={() => _goPrevPage()}>Prev</Pagination.Prev>
    }
  }

  const nextBtn = () => {
    if (page !== totalPage - 1) {
      if (page <= high) {
        return <Pagination.Prev onClick={() => _goNextPage()}>Next</Pagination.Prev>
      }
      else {
        setHigh(high + perPage)
        setLow(low + perPage)
      }
    }
  }

  const ListItem = (page: any) => {
    return page.value + 1
  }
  const PageNumber = pagination.map((p, i) => {
    var pagination_num: ReactNode;
    if ((p === 0 && page === 0) || (p === 1 && page === 1)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} key={i} active={p === page}><ListItem value={p} /></Pagination.Item>
    }
    else if ((p < high + 1) && (p >= low - 1)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} key={i} active={p === page}><ListItem value={p} /></Pagination.Item>
    }
    return (
      pagination_num
    )
  })


  return (
    <Main>
      <Text variant="title">Company Type List</Text>
      <Space divheight={15} />
      <Card>
        <SearchForm>
          <Row className='m-0 p-0'>
            <Col xs='12' sm='12' md='12' lg='4' xl='4' className='m-0 p-0'>
              <div className='mr-2 mb-2 mb-sm-2 mb-md-2 mb-lg-0 mb-xl-0'>
                <Row className='m-0 p-0'>
                  <Col xs='12' sm='10' md='9' lg='12' xl='12' className='m-0 p-0'>
                    <Button variant='transparent' onClick={() => _willAddNewCompany()}>
                      <Flex>
                        <Icons icon="add" color="#ffffff" />
                        ADD NEW Company
                      </Flex>
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </SearchForm>
        {/* <SearchForm>
          <Row className='m-0 p-0'>
            <Col xs='12' sm='12' md='12' lg='4' xl='4' className='m-0 p-0'>
              <div className='mr-2 mb-2 mb-sm-2 mb-md-2 mb-lg-0 mb-xl-0'>
                <Row className='m-0 p-0'>
                  <Col xs='12' sm='10' md='9' lg='12' xl='12' className='m-0 p-0'>
                    <InputWithIcon
                      type="text"
                      value={searchInput}
                      onChange={(e) => _searchFuntion(e.target.value)}
                      placeholder="Search by Company Type.."
                      icon="search"
                      id="search-inputCmpType"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs='12' sm='12' md='12' lg='8' xl='8' className='m-0 p-0'>
              <Row className='m-0 p-0'>
                <Col xs='6' sm='4' md='4' lg='3' xl='3' className='m-0 p-0 mr-2'>
                  <Button variant='transparent' onClick={() => _willAddNewCompany()}>
                    <Flex>
                      <Icons icon="add" color="#ffffff" />
                      ADD NEW Company
                    </Flex>
                  </Button>
                </Col>
                <Col xs='5' sm='4' md='4' lg='3' xl='3' className='m-0 p-0 '>
                  <div>
                    <Button className='ml-2' variant='transparent' block={true} onClick={() => _showAll()}>
                      Show All
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </SearchForm> */}
        {isLoading && <Text center>
          <Loader
            type="Rings"
            color="#233269"
            height={100}
            width={100}
            timeout={30000}
          />
        </Text>}
        {!isLoading && displayCompany.length === 0 && (
          <>
            <Space divheight={20} />
            <Text center>No Company Type found</Text>
            <Space divheight={20} />
          </>
        )}
        {!isLoading && displayCompany.length > 0 && (
          <>
            <Table>
              <thead>
                <tr key={0}>
                  <th>S.No</th>
                  <th>Company Type</th>
                  <th colSpan={2} className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {displayCompany.map((cmp: any, i: any) => (
                  <tr key={cmp.id}>
                    <td data-label='S.No'>
                      {page === 0 && (
                        i + 1
                      )}
                      {page >= 1 && (
                        (page * 10) + (i + 1)
                      )}
                    </td>
                    <td data-label='Company Type'>
                      {cmp.name}
                    </td>
                    <td>
                      <TableActions>
                        <OverlayTrigger overlay={
                          <Tooltip id="cmp-view"> View
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => _willViewDetail(cmp)}>
                            <Icons color="#52575a" icon="remove_red_eye" />
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={
                          <Tooltip id="cmp-edit"> Edit
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => _willViewEdit(cmp)}>
                            <Icons color="#52575a" icon="edit" />
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={
                          <Tooltip id="cmp-delete"> Delete
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => handleShow(cmp)}>
                            <Icons color="#52575a" icon="delete" />
                          </Button>
                        </OverlayTrigger>
                      </TableActions>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <TableFooter>
              <Text>
                {displayCompany.length === 1 && (
                  <>
                    <b>
                      {displayCompany.length}
                      {/* {((page)*10)+1} - {(displayCompany.length+(page)*10)} */}
                    </b> of {totalElement} Company
                  </>
                )}
                {displayCompany.length > 1 && (
                  <>
                    <b>
                      {displayCompany.length}
                      {/* {((page)*10)+1} - {(displayCompany.length+(page)*10)} */}
                    </b> of {totalElement} Companies
                  </>
                )}
              </Text>
              <Pagination size="sm">
                {firstPage()}
                {prevBtn()}
                {PageNumber}
                {nextBtn()}
                {lastPage()}
              </Pagination>
            </TableFooter>
          </>
        )}
      </Card>
      {/* {console.log(showModal, 'showmodal')} */}
      {showModal && <AddCompany onClose={() => _willCloseModal()} edit={isEdit} view={isview} user_id={1} />}
      <Modal show={showDelete} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Text variant='title-sm' color='main' bold>
              Confirmation
            </Text>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text bold variant='confirmation' color='danger' values='Permanently you want to delete this item form Company type list' />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='transparent' onClick={handleClose}>
            <Icons icon="close" />
            Close
          </Button>
          <Button variant='transparent' onClick={() => _willDelete()}>
            <Icons icon="delete_forever" />
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Main>
  )
}

export interface TablefooterProps {
  children?: React.ReactNode
}

const TableFooter = (props: TablefooterProps) => {

  const tablefooter = classNames('tablefooter')

  return (
    <Flex jc='jc-between' className={tablefooter}>
      {props.children}
    </Flex>
  )

}

export interface TableActionsProps {
  children?: React.ReactNode
}

const TableActions = (props: TableActionsProps) => {

  const tableAction = classNames('tableAction')

  return (
    <Flex jc='jc-center' className={tableAction}>
      {props.children}
    </Flex>
  )

}

interface searchProps {
  children?: React.ReactNode
}

const SearchForm = (props: searchProps) => {

  const search = classNames('serachForm')
  return (
    <form autoComplete='off' className={search}>
      {props.children}
    </form>
  )
}

const mapStateToProps = (state: any) => ({
  cmpTypes: state.cmpTypes.cmpTypes,
  isLoading: state.cmpTypes.isLoading,
  error: state.cmpTypes.error,
  totalElement: state.cmpTypes.totalElement,
  totalPage: state.cmpTypes.totalPage,
})

export default connect(
  mapStateToProps,
  {
    cmpTypeListGetAction,
    cmpTypeSetSelectedAction,
  }
)(CompanyTypesList)
